<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card>
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <category-card />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <services-title />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <services-scode-card />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <services-department-select />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <services-team-select />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <services-description-card />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <services-notes-card />
          </b-col>
        </b-row>
      </b-card>
      <urls-card />
      <services-image-card />
      <b-alert
        v-if="!checkCodeResult.status"
        show
        variant="danger"
      >
        <div class="alert-body text-center">
          {{ checkCodeResult.message }}
        </div>
      </b-alert>
      <div v-else>
        <save-button
          :save-action="submitForm"
          :is-disabled="submitStatus"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import ServicesTitle from '@/views/Services/Elements/TitleCard.vue'
import ServicesScodeCard from '@/views/Services/Elements/ScodeCard.vue'
import ServicesDepartmentSelect from '@/views/Services/Elements/DepartmentsCard.vue'
import ServicesTeamSelect from '@/views/Services/Elements/TeamsCard.vue'
import ServicesDescriptionCard from '@/views/Services/Elements/DescriptionCard.vue'
import ServicesNotesCard from '@/views/Services/Elements/NotesCard.vue'
import ServicesImageCard from '@/views/Services/Elements/ImageCard.vue'
import CategoryCard from '@/views/Services/Elements/CategoryCard.vue'
import UrlsCard from '@/views/Services/Elements/UrlsCard.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'

export default {
  name: 'ServicesServiceCard',
  components: {
    ValidationObserver,
    SaveButton,
    ServicesImageCard,
    CategoryCard,
    UrlsCard,
    ServicesNotesCard,
    ServicesDescriptionCard,
    ServicesTeamSelect,
    ServicesDepartmentSelect,
    ServicesScodeCard,
    ServicesTitle,
    BCard,
    BRow,
    BCol,
    BAlert,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    saveData() {
      return this.$store.getters['services/dataSaveStatus']
    },
    checkCodeResult() {
      return this.$store.getters['services/checkCodeResult']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        // Yalnız yeni kayıtta listeye dön; güncellemede formda kal
        if (!this.$route.params.id) {
          this.$router.push('/app/services')
        }
        this.submitStatus = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      if (this.$route.params.id) {
        this.$store.dispatch('services/getDataItem', this.$route.params.id)
          .then(response => {
            // Arşivdeki kayıt düzenlenemez; görüntüleme sayfasına yönlendir
            if (response && response.archived) {
              this.$router.replace(`/app/services/view/${this.$route.params.id}`)
              return
            }
            if (response && response.id_departments) {
              this.getTeams()
            }
          })
      }
    },
    getTeams() {
      if (this.dataItem.id_departments) {
        this.$store.dispatch('teams/getDataList', {
          select: [
            'teams.id AS id',
            'teams.title AS title',
          ],
          where: {
            'teams.status': 1,
            'teams.id_departments': this.dataItem.id_departments,
          },
        })
      } else {
        this.dataItem.id_teams = null
      }
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('services/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
